<template>
    <div>
  
      <div class="card">
        <div class="card-body">
  
          <div class="position-relative wd-50">
            <input v-on:keyup.enter="load(1)" type="text" class="form-control ps-5" v-model="filters.search" placeholder="Search by description..."> <span class="position-absolute top-50 product-show translate-middle-y"><i class="bx bx-search"></i></span>
          </div>
  
          <br/>
  
          <button type="button" style="float: right"  data-bs-toggle="modal" data-bs-target="#createCallModal" class="btn btn-sm btn-primary px-5" @click="reset">New Call</button>
  
          <pagination @search="load" :data="pagination"></pagination>
  
          <table id="example" class="table table-hover" style="width:100%">
            <thead>
            <tr>
              <th>Description</th>
              <th>Call Start Time</th>
              <th>Call End Time</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="data.length < 1">
              <td colspan="2" class="text-center">No record found.</td>
            </tr>
            <tr v-for="d in data" :key="d.id" style="cursor: pointer;">
              <td>{{d.description}}</td>
              <td>{{d.call_start_time}}</td>
              <td>{{d.call_end_time}}</td>
              <td><button type="button" class="btn btn-danger" @click="deleteCall(d.id)">Delete</button></td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th>Description</th>
              <th>Call Start Time</th>
              <th>Call End Time</th>
              <th></th>
            </tr>
            </tfoot>
          </table>
  
          <pagination @search="load" :data="pagination"></pagination>
        </div>
      </div>
  
      <!-- MODALS -->
  
      <div class="modal fade" id="createCallModal" tabindex="-1" style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Record Call</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 mb-2">
                  <p>Fields marked <span class="text-danger">*</span> are required</p>
                </div>
                <div class="col-md-12 mb-2">
                  <button v-if="!call.started" type="button" class="btn btn-success" @click="recordCall('start')">Start Call</button>
                  <button v-else type="button" class="btn btn-secondary">Call started at {{ call.startDisplay }}</button>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="callDescription" class="form-label">Description <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" id="callDescription" v-model="call.description">
                </div>
                <div class="col-md-12 mb-2">
                  <button v-if="!call.ended" type="button" class="btn btn-danger" @click="recordCall('end')">End Call</button>
                  <button v-else type="button" class="btn btn-secondary">Call ended at {{ call.endDisplay }}</button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id='closeCreateCallModal'>Close</button>
              <submit-button type="button" :background="'btn btn-primary'" :clicked="creating" @click="submitCall" text="Save changes"></submit-button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  /* global $ */
  import axios from 'axios';
  import Pagination from '../../../components/Pagination.vue';
  import SubmitButton from '../../../components/SubmitButton.vue';
  export default {
    components: { Pagination, SubmitButton },
    name: 'admin.support',
    props: {
        site: Object
    },
    data(){
      return {
        data: [],
        pagination: {
          lastPage: 0,
          page: 0,
          showing: 0,
          total: 0
        },
        call: {
          description: '',
          start: null,
          startDisplay: null,
          started: false,
          end: null,
          endDisplay: null,
          ended: false
        },
        creating: false,
        filters: {
          search: ""
        },
      }
    },
    mounted(){
      this.load();
    },
    methods: {
        load(page = 1){
        axios.get(`${process.env.VUE_APP_API_URL}/v1/sites/${this.site.id}/support?page=${page}&search=${this.filters.search}`)
            .then(response => {
              this.data = response.data.support;
                this.data.forEach(product => {
                    product.call_start_time = new Date(product.call_start_time).toISOString().slice(0, 19).replace('T', ' ');
                    product.call_end_time = new Date(product.call_end_time).toISOString().slice(0, 19).replace('T', ' ');
                });
              this.pagination = response.data.pagination;
            })
            .catch(error => {
              this.$error('Failed to load support.', error);
            });
      },
      recordCall(type){
        if (type === 'start') {
            this.call.startDisplay = new Date().toISOString().slice(0, 19).replace('T', ' ');
            this.call.start = Math.floor(Date.now() / 1000);
            this.call.started = true;
        } else {
            this.call.endDisplay = new Date().toISOString().slice(0, 19).replace('T', ' ');
            this.call.end = Math.floor(Date.now() / 1000);
            this.call.ended = true;
        }
      },
      reset(){
        this.call = {
          description: '',
          start: null,
          startDisplay: null,
          started: false,
          end: null,
          endDisplay: null,
          ended: false
        }
      },
      submitCall(){
        this.creating = true;
        axios.put(`${process.env.VUE_APP_API_URL}/v1/sites/${this.site.id}/support`, this.call)
            .then(() => {
              $('#closeCreateCallModal').click();
              this.$success("Created new call log");
              this.creating = false;
              this.reset();
              this.load(this.pagination.page);
            })
            .catch(error => {
              this.$error("Failed to submit call record.", error);
              this.creating = false;
            })
      },
      deleteCall(id){
        axios.delete(`${process.env.VUE_APP_API_URL}/v1/sites/${this.site.id}/support/${id}`)
            .then(() => {
              this.$success("Deleted call log");
              this.load(this.pagination.page);
            })
            .catch(error => {
              this.$error("Failed to delete call record.", error);
            })
      },
    }
  }
  </script>